// ROUTES
import { ROUTE_IIRGD } from 'routes/paths';

export const ROUTE_IIRGD_PESQUISAR_DBCIN = `${ROUTE_IIRGD}/pesquisa-dbcin`;
export const ROUTE_IIRGD_RESULTADO_DBCIN = `${ROUTE_IIRGD}/resultado/pesquisa-dbcin`;
